import React from 'react';
import Localize from 'react-intl-universal';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import ParticipantCard from './ParticipantCard';
import ParticipantDialog from './ParticipantDialog';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.booking.list,
  height: '100%',
  padding: '2rem 1rem 1rem 1rem',
  overflow: 'auto',

  [theme.breakpoints.up('xs')]: {
    height: 'max-content'
  },
  [theme.breakpoints.up('md')]: {
    height: 'max-content'
  },
  [theme.breakpoints.up('lg')]: {
    height: '67.3vh'
  }
}));

const StyledHeader = styled(Box)(({ theme }) => ({
  marginTop: '0.5rem',
  marginBottom: '1rem',
  paddingTop: 0,
  fontSize: '20px',
  color: theme.palette.booking.header
}));

const StyledMessage = styled(Box)(({ theme }) => ({
  marginBottom: '0.5rem',
  border: `1px solid ${theme.palette.grey[200]}`,
  padding: '1rem',
  textAlign: 'center',
  color: theme.palette.error.main
}));

const BookingParticipants = ({
  configuration = {},
  bookingPersonRadio,
  participants,
  setParticipants,
  maxParticipant,
  isEventFree = false,
  isEventIlias
}) => {
  const participantWithoutBookingPerson = participants.filter(
    (participant) => !participant.isBookingPerson
  );
  return (
    <>
      <StyledBox>
        <StyledHeader>{Localize.get('EventDetails.participants')}</StyledHeader>
        <Box>
          {participants.map((participant, index) => (
            <ParticipantCard
              key={index}
              participant={participant}
              index={index}
              bookingPersonRadio={bookingPersonRadio}
              participants={participants}
              setParticipants={setParticipants}
              configuration={configuration}
              isEventFree={isEventFree}
              isEventIlias={isEventIlias}
            />
          ))}
        </Box>
        {!participantWithoutBookingPerson?.length ? (
          <StyledMessage>{Localize.get('Booking.atLeastOne')}</StyledMessage>
        ) : participantWithoutBookingPerson?.length === maxParticipant ? (
          <StyledMessage data-testid='max-participant-error'>
            {Localize.get('Booking.maxNumberOfParticipants', { count: maxParticipant })}
          </StyledMessage>
        ) : null}
        <ParticipantDialog
          configuration={configuration}
          mode={'create'}
          setParticipants={setParticipants}
          participants={participants}
          disableButton={participantWithoutBookingPerson?.length === maxParticipant}
          isEventFree={isEventFree}
          isEventIlias={isEventIlias}
        />
      </StyledBox>
    </>
  );
};
export default BookingParticipants;
